<template>
  <div>
    <br>
    <qrcode-vue :value="value" :size="size" level="H"></qrcode-vue>
    <br>
    <b-container fluid>
      <b-row>
        <b-col></b-col>
        <b-col sm="4">
          <b-form-textarea rows="6" v-model="value"></b-form-textarea>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  data() {
    return {
      value: this.$route.query.d,
      size: 300
    }
  },
  components: {
    QrcodeVue
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Qrcode.vue